export default "__VITE_ASSET__332c7121__"